import { modifyColContent } from './useTemplateModel.js';

export const updateColContent = async (activeComponents, templateEditModel, editor) => {
    activeComponents.editor.active = true;
    activeComponents.editor.instance = editor;
    modifyColContent(
        templateEditModel,
        activeComponents.content.rowId,
        activeComponents.content.colId,
        editor.getHTML(),
    );
};

// Activate content editor instance
export const focusColContent = async (activeComponents, editor) => {
    activeComponents.editor.active = true;
    activeComponents.editor.instance = editor;
};

// Activate row and col content, sidebar context
export const setActiveContent = (activeComponents, content) => {
    if (content.id !== activeComponents.content.id) {
        activeComponents.editor.active = false;
        activeComponents.editor.instance = null;
        activeComponents.content = content;
    }
};

export const showSortedDocument = (templateEditModel, event) => {
    const item = templateEditModel.template.body.splice(event.oldIndex, 1)[0];
    templateEditModel.template.body.splice(event.newIndex, 0, item);
};

export const resetActiveBlockSelection = (activeComponents, templateModel) => {
    activeComponents.col.id = '';
    activeComponents.row.id = '';
    activeComponents.content = {
        rowId: '',
        colId: '',
        cssClass: '',
        id: '',
        html: '',
        tag: '',
        inlineStyle: [],
        style: {},
    };
    activeComponents.editor = {
        active: false,
        type: templateModel.type,
        instance: null,
    };
};

export const blurColContent = async (activeComponents, editor) => {
    console.log('blurColContent: EVENT BLUR DOM', editor.view.dom.parentElement.parentElement.id);
};

export const sizeInfoHandler = {
    on: (event) => {
        const validElements = ['TH', 'TD', 'IMG'];
        const closestValidTarget = event.target.closest('img ,tr>th, tr>td');
        let realTarget = event.target;

        if (closestValidTarget?.tagName && validElements.includes(closestValidTarget.tagName)) {
            realTarget = closestValidTarget;
        }

        if (validElements.includes(realTarget.tagName)) {
            let infoBox = document.getElementById('size-info');

            if (!infoBox) {
                infoBox = document.createElement('div');
                infoBox.id = 'size-info';
                infoBox.style.pointerEvents = 'none';
                document.body.appendChild(infoBox);
            }

            const targetWidth = realTarget.offsetWidth;
            infoBox.textContent = `🔳\xa0${targetWidth}px`;
            if (realTarget.tagName === 'IMG') {
                const targetHeight = realTarget.offsetHeight;
                infoBox.textContent = `🎨\xa0${targetWidth}\xa0✖\xa0${targetHeight}px`;
            }
            // Pozice info boxu
            infoBox.style.left = `${event.clientX + 15}px`;
            infoBox.style.top = `${event.clientY + 15}px`;
        }
    },
    off: () => {
        let infoBox = document.getElementById('size-info');
        if (infoBox) {
            infoBox.remove();
        }
    },
};

export const buttonState = (ready = true, active = false) => {
    const states = {
        active: 'text-blue-600 hover:bg-gray-200',
        ready: 'text-gray-500 hover:bg-gray-200',
        disabled: 'text-gray-300 cursor-not-allowed',
    };
    if (ready && active) {
        return states.active;
    }
    return ready ? states.ready : states.disabled;
};

export const useSnippets = () => {
    return {
        updateColContent: updateColContent,
        focusColContent: focusColContent,
        setActiveContent: setActiveContent,
        showSortedDocument: showSortedDocument,
        resetActiveBlockSelection: resetActiveBlockSelection,
        blurColContent: blurColContent,
        sizeInfoHandler: sizeInfoHandler,
        buttonState: buttonState,
    };
};

export default useSnippets;
